import React from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Typography,
} from "@material-tailwind/react";

const ProductCard = ({item}) => {
  return (
    <Card className="w-36 md:w-72 border p-5 rounded-xl shadow-lg">
      <CardHeader color="blue" className="relative">
        <img
          src={item?.image}
          // alt="img-blur-shadow"
          className="h-full w-full"
        />
      </CardHeader>
      <CardBody className="text-center">
        <Typography className="text-sm md:text-xl my-2 truncate">
         {item?.name}
        </Typography>
      </CardBody>
      <CardFooter divider className="flex items-center justify-between py-3">
        <Typography variant="small">{item?.price}</Typography>
      </CardFooter>
    </Card>
  );
};

export default ProductCard;
